import { normalizeBoolean } from '@change/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_STARFISH_SMART_IMAGE_BANDITS_V2 = createFcmConfig('starfish_smart_image_bandits_v2', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
